export const TURNOVERFORECASTSETTINGSLIST_SEARCH = 'TURNOVERFORECASTSETTINGSLIST_SEARCH';
export const TURNOVERFORECASTSETTINGSLIST_PAGE = 'TURNOVERFORECASTSETTINGSLIST_PAGE';
